import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import logo from "../assets/mainlogo.png";
import bg1 from "../assets/bg1.png";
import bg2 from "../assets/bg2.png";
import "./Home.css";
import { FaInstagram, FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const texts = [
  "Enterprise Web Development",
  "Mobile App Development",
  "AI & Automation Solutions",
  "Custom Software Engineering",
  "E-commerce Website Development",
  "Product Catalog & Listing Management",
  "Website Maintenance & Support",
  "Cloud & DevOps Services",
  "UI/UX Experience Design",
  "SaaS Product Development",
  "Digital Marketing Solutions",
  "SEO & Performance Optimization",
  "API Development & Integration",
  "Digital Transformation"]
const bgImages = [bg1, bg2];

export default function Home() {
  const [textIndex, setTextIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [charIndex, setCharIndex] = useState(0);
  const [imgIndex, setImgIndex] = useState(0);
  

  // Typing Effect
  useEffect(() => {
    if (charIndex < texts[textIndex].length) {
      const t = setTimeout(() => {
        setDisplayText((p) => p + texts[textIndex][charIndex]);
        setCharIndex((c) => c + 1);
      }, 100);
      return () => clearTimeout(t);
    } else {
      const t = setTimeout(() => {
        setDisplayText("");
        setCharIndex(0);
        setTextIndex((i) => (i + 1) % texts.length);
      }, 1500);
      return () => clearTimeout(t);
    }
  }, [charIndex, textIndex]);

  // Background Change
  useEffect(() => {
    const interval = setInterval(() => {
      setImgIndex((i) => (i + 1) % bgImages.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);
  

  return (
    <>
      {/* HERO */}
      <div
        className="hero"
        style={{ backgroundImage: `url(${bgImages[imgIndex]})` }}
      >
        <div className="hero-wrapper">
          
          <motion.div
            className="logo-box"
            initial={{ opacity: 0, x: -80 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <img src={logo} alt="TevixRA Logo" />
          </motion.div>

          <motion.div
            className="hero-content"
            initial={{ opacity: 0, x: 80 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <h1 className="company-title">TevixRA</h1>

            <h2 className="typing-text">
              {displayText}
              <span className="cursor">|</span>
            </h2>

           
          </motion.div>
        </div>
      </div>

    {/* ================= PREMIUM ABOUT ================= */}
<section className="about-premium">
  <div className="about-premium-container">

    <motion.div
      className="about-left"
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <h2>
        We Don’t Just Build Websites.  
        <span>We Build Digital Growth.</span>
      </h2>

      <p>
        TevixRA Solutions is a results-driven digital company helping 
        startups and businesses scale online. From modern websites to 
        powerful mobile apps and smart analytics — we create solutions 
        that convert visitors into customers.
      </p>

      <p>
        Our focus is performance, design excellence, and long-term 
        client success. We partner with businesses to transform 
        ideas into profitable digital products.
      </p>

     
    </motion.div>

    <motion.div
      className="about-right"
      initial={{ opacity: 0, scale: 0.8 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <div className="about-card">
        <h3>100+</h3>
        <p>Projects Delivered</p>
      </div>

      <div className="about-card">
        <h3>50+</h3>
        <p>Happy Clients</p>
      </div>

      <div className="about-card">
        <h3>5+</h3>
        <p>Years Experience</p>
      </div>
    </motion.div>

  </div>
</section>

      {/* SERVICES */}
      <motion.section
        className="services-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.3,
            },
          },
        }}
      >
        <h2>Our Services</h2>

        <div className="services-container">
          {texts.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              variants={{
                hidden: { opacity: 0, y: 40 },
                visible: { opacity: 1, y: 0 },
              }}
              transition={{ duration: 0.6 }}
              whileHover={{ scale: 1.05 }}
            >
              <h3>{service}</h3>
              <p>Professional and high-quality solutions.</p>
            </motion.div>
          ))}
        </div>
      </motion.section>
      {/* ================= NEXT WHY CHOOSE ================= */}
<section className="why-advanced">

  <motion.h2
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    viewport={{ once: true }}
  >
    Why Choose TevixRA Solutions?
  </motion.h2>

  <div className="why-advanced-grid">
    {[
      { title: "High Conversion Design", desc: "Websites built to convert visitors into customers." },
      { title: "Performance Optimized", desc: "Lightning fast loading & smooth experience." },
      { title: "Business Focused Strategy", desc: "We focus on growth, not just design." },
      { title: "Long Term Partnership", desc: "We support your business beyond launch." }
    ].map((item, index) => (
      <motion.div
        key={index}
        className="why-advanced-card"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: index * 0.2 }}
        viewport={{ once: true }}
      >
        <h3>{item.title}</h3>
        <p>{item.desc}</p>
      </motion.div>
    ))}
  </div>
</section>
{/* ================= OUR PROCESS ================= */}
<section className="process-section">
  <h2>Our Work Process</h2>

  <div className="process-container">
    {[
      "1️⃣ Discussion",
      "2️⃣ Planning",
      "3️⃣ Design",
      "4️⃣ Development",
      "5️⃣ Testing",
      "6️⃣ Launch"
    ].map((step, index) => (
      <motion.div
        className="process-step"
        key={index}
        initial={{ scale: 0 }}
        whileInView={{ scale: 1 }}
        transition={{ duration: 0.4, delay: index * 0.1 }}
        viewport={{ once: true }}
      >
        {step}
      </motion.div>
    ))}
  </div>
</section>

{/* ================= ULTRA CASE STUDY ================= */}
<section className="case-advanced">

  <div className="case-advanced-container">

    <motion.div
      className="case-before-after"
      initial={{ opacity: 0, x: -80 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <h3>Before</h3>
      <ul>
        <li>❌ Outdated Design</li>
        <li>❌ Low Traffic</li>
        <li>❌ Poor User Experience</li>
      </ul>

      <h3>After</h3>
      <ul>
        <li>✅ Modern UI/UX</li>
        <li>✅ SEO Optimized</li>
        <li>✅ High Conversion Funnel</li>
      </ul>
    </motion.div>

    <motion.div
      className="case-result"
      initial={{ opacity: 0, x: 80 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <h2>Results Achieved 🚀</h2>

      <div className="case-stats">
        <div>
          <h3>+65%</h3>
          <p>Increase in Leads</p>
        </div>

        <div>
          <h3>+40%</h3>
          <p>Increase in Sales</p>
        </div>

        <div>
          <h3>+120%</h3>
          <p>Website Speed</p>
        </div>
      </div>

    
    </motion.div>

  </div>
</section>
      {/* ================= PORTFOLIO ================= */}
<section className="portfolio-section">
  <h2>Our Recent Projects</h2>

  <div className="portfolio-container">

    <div className="portfolio-card">
      <img src="https://images.unsplash.com/photo-1498050108023-c5249f4df085" alt="Project 1" />
      <div className="portfolio-overlay">
        <h3>Business Website</h3>
        <p>Modern responsive company website.</p>
        <button>View Project</button>
      </div>
    </div>

    <div className="portfolio-card">
      <img src="https://images.unsplash.com/photo-1551650975-87deedd944c3" alt="Project 2" />
      <div className="portfolio-overlay">
        <h3>Mobile App UI</h3>
        <p>Android & iOS app development.</p>
        <button>View Project</button>
      </div>
    </div>

    <div className="portfolio-card">
      <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f" alt="Project 3" />
      <div className="portfolio-overlay">
        <h3>Analytics Dashboard</h3>
        <p>Data analytics & business insights.</p>
        <button>View Project</button>
      </div>
    </div>

  </div>
</section>
      {/* ================= TESTIMONIALS ================= */}
<section className="testimonial-section">
  <h2>Our Satisfied Clients</h2>

  <Slider
    dots={true}
    infinite={true}
    speed={800}
    slidesToShow={3}
    slidesToScroll={1}
    autoplay={true}
    autoplaySpeed={2500}
    responsive={[
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]}
  >
    {[
      {
        img: "https://randomuser.me/api/portraits/men/32.jpg",
        name: "Rahul Sharma",
        text: "Amazing website service! Highly professional team."
      },
      {
        img: "https://randomuser.me/api/portraits/women/44.jpg",
        name: "Anita Verma",
        text: "My sales increased after their web development work."
      },
      {
        img: "https://randomuser.me/api/portraits/men/12.jpg",
        name: "Amit Patel",
        text: "Best support and fast delivery. Highly recommended!"
      },
      {
        img: "https://randomuser.me/api/portraits/women/68.jpg",
        name: "Priya Mehta",
        text: "Top quality development and amazing support."
      }
    ].map((client, index) => (
      <div key={index}>
        <div className="testimonial-card">
          <img src={client.img} alt={client.name} />
          <h3>{client.name}</h3>
          <p>"{client.text}"</p>
          <div className="stars">⭐⭐⭐⭐⭐</div>
        </div>
      </div>
    ))}
  </Slider>
</section>


{/* FOOTER */}
      <motion.footer
        className="footer"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <div className="footer-content">
          <h3>TevixRA Solutions</h3>

          <div className="social-icons">
            <a href="https://www.instagram.com/tevixra/" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61587698916090" target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://www.linkedin.com/in/tevixra-undefined-0136463b5/" target="_blank" rel="noreferrer">
              <FaLinkedinIn />
            </a>
            <a href="https://x.com/TevixRa" target="_blank" rel="noreferrer">
              <FaTwitter />
            </a>
          </div>

          <p>© 2026 TevixRA Solutions | All Rights Reserved</p>
        </div>
        
      </motion.footer>
    </>
    
  );
}